import {Component, input, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {DcpResourceData} from '@app/model/dcp-resource-data';
import {ProductTileContentComponent} from '../product-tile-content/product-tile-content.component';

@Component({
    selector: 'dcp-product-resource-tile',
    templateUrl: './product-resource-tile.component.html',
    standalone: true,
    imports: [ProductTileContentComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductResourceTileComponent {
  resource = input.required<DcpResourceData>();

  get hasImage(): boolean {
    return !!this.resource()?.source;
  }
}
